var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 0H4.66667C4.20667 0 3.84667 0.233333 3.60667 0.586667L0 6L3.60667 11.4067C3.84667 11.76 4.20667 12 4.66667 12H14.6667C15.4 12 16 11.4 16 10.6667V1.33333C16 0.6 15.4 0 14.6667 0ZM12.6667 8.39333L11.7267 9.33333L9.33333 6.94L6.94 9.33333L6 8.39333L8.39333 6L6 3.60667L6.94 2.66667L9.33333 5.06L11.7267 2.66667L12.6667 3.60667L10.2733 6L12.6667 8.39333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearWhite);
export default __webpack_public_path__ + "static/media/clear-white.edbf671d4d72d02c81a079ea0f349631.svg";
export { ForwardRef as ReactComponent };